

/**
 * Lookup a postcode via postcodes.io
 *
 * @param	{string}	p
 * @return	{bool}
 */
function biro_postcode_lookup( p ) {

  // Sanitize input
  p = p.replace( ' ', '' );
  p = p.replace( /[^a-zA-Z0-9]/, '' );

  // Try to get JSON response
  // Using synchronous AJAX
  var request = new XMLHttpRequest();
  request.open( 'GET', 'https://api.postcodes.io/postcodes/' + p, false );
  request.send();

  // Check the status of the response
  if ( request.status === 200 ) {

    // Access the data returned by the server
    var data = request.response;
    return JSON.parse( data );

  } else {

    // Handle error
    alert( "Sorry, there's been a problem looking up your postcode.\n\nPlease try again." );

  }

}
